import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);

  const reload = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) {
      setSession(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setSession(data);
    } catch {
      setSession(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  useEffect(() => {
    const onFocus = () => { if (localStorage.getItem(TOKEN_KEY)) reload(); };
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [reload]);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setSession(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    localStorage.removeItem(TOKEN_KEY);
    setSession(false);
  };

  const can = (perm) => !!session && session.permissions.includes(perm);

  const switchTenant = async (tenantId) => {
    const { data } = await api.post("/auth/switch-tenant", { tenant_id: tenantId || null });
    setSession(data);
    return data;
  };

  return (
    <AuthCtx.Provider value={{ session, user: session?.user, tenant: session?.tenant, login, logout, can, reload, switchTenant }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
